import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['section'];

  toggle(event) {
    if (!this.hasSectionTarget) return;

    const broker = event.target.value === 'broker';
    this.sectionTarget.classList.toggle('hidden', !broker);
    this.sectionTarget.querySelectorAll('input').forEach((input) => {
      input.disabled = !broker;
    });
  }
}
